<template>
  <div class="HEADER d-flex ai-center bd-b-gray30 p-x-2 p-y-1" selenium="consumer-inbox-header">
    <info
        :job="job"
        :skills-profile-id="skillsProfileId"
        tight
        class="INFO flex-0-0"/>
    <div class="DETAILS flex-1-1">
      <div class="h5 text-bold text-center m-b-1" selenium="consumer-inbox-service">
        {{ job.service_display_name }}
      </div>
      <div class="GRID">
        <div>
          <div class="LABEL">Requested</div>
          <div class="VALUE">{{ job.time_created | formatDate('M/d/yyyy') }}</div>
        </div>
        <div v-if="location">
          <div class="LABEL">Location</div>
          <div class="VALUE">{{ location }}</div>
        </div>
        <div>
          <div class="LABEL">Notes</div>
          <div class="VALUE">{{ job.description || '(not provided)' }}</div>
        </div>
        <div>
          <div class="LABEL">Photos</div>
          <div class="VALUE">{{ photos }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Info from '@/views/Consumer/views/Messages/components/Info';

export default {
  name: 'conversation-header',
  components: { Info },
  props: {
    job: {
      type: Object,
      required: true,
    },
    skillsProfileId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    location () {
      const address = this.job.user && this.job.user.address;
      return address ? [address.city, address.state].filter(Boolean).join(', ') : '';
    },
    photos () {
      const count = (this.job.attachments || []).length;
      return count ? `${count} attached` : '(not provided)';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .HEADER {
    flex: 0 0 auto;
    @include mobile-only() {
      flex-direction: column;
      // Small screens: cap the header and scroll inside it so the chat always keeps its space
      max-height: 35vh;
      overflow-y: auto;
    }
  }
  .INFO { width: 200px; }
  .DETAILS { min-width: 0; padding: 0 $unit * 2; }
  .GRID {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: $unit;
    @include mobile-only() {
      grid-template-columns: 1fr;
    }
  }
  .LABEL { font-size: 12px; font-weight: 700; color: $color-gray90; }
  .VALUE { font-size: 12px; color: $color-gray60; overflow-wrap: anywhere; }
</style>
